var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM9.99 8H9C8.74512 8.00028 8.49997 8.09788 8.31463 8.27285C8.1293 8.44782 8.01777 8.68695 8.00283 8.94139C7.98789 9.19584 8.07067 9.44638 8.23426 9.64183C8.39785 9.83729 8.6299 9.9629 8.883 9.993L9 10V14.99C9 15.51 9.394 15.94 9.9 15.994L10.01 16H10.5C10.7103 16 10.9153 15.9337 11.0857 15.8105C11.2562 15.6873 11.3835 15.5135 11.4495 15.3139C11.5155 15.1142 11.5169 14.8988 11.4534 14.6982C11.3899 14.4977 11.2649 14.3223 11.096 14.197L11 14.134V9.01C11 8.49 10.606 8.06 10.1 8.006L9.99 8ZM10 5C9.73478 5 9.48043 5.10536 9.29289 5.29289C9.10536 5.48043 9 5.73478 9 6C9 6.26522 9.10536 6.51957 9.29289 6.70711C9.48043 6.89464 9.73478 7 10 7C10.2652 7 10.5196 6.89464 10.7071 6.70711C10.8946 6.51957 11 6.26522 11 6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfor);
export default __webpack_public_path__ + "static/media/INFOR.dd9f703e17bcbc12b55c9831895af1ce.svg";
export { ForwardRef as ReactComponent };